<template>
  <div class="panel-item ">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>仓库信息</div>

    </div>
    <dv-scroll-board :config="config" class="panel-item_datav"/>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default:[]
    },
  },
  data() {
    return {
      type: 1,//1 店铺、2 商品


      config: {
        header: ['仓库名', '现有库存', '未入仓', '待出仓'],
        data: [],
        headerBGC: '#053355',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        headerHeight: 30,
        hoverPause: true,
        // waitTime: 99999999,
        align: ['center', 'center', 'center', 'center'],
        columnWidth: [140, 140, 120, 120] // 调整列宽，中间列为产品名称宽度

      },
      detailVisible: false,
      detail: {},

    }
  },
  mounted() {
  },
  methods: {
    setData(newVal){
      const newData = newVal.map((item, index) => [
        `<div >${item.warehouse_name}</div>`,
        `<div >${item.stock_num}</div>`,
        `<div >${item.purchase_num}</div>`,
        `<div >${item.sending_num}</div>`,
        // `<div >${item.stock_num}</div>`,
        // `<div class="right_box">${item.actual_paid || '0'}</div>`
      ])

      this.config = Object.assign({}, this.config, {
        data: newData
      })
    }
  },
// 修改 watch 中的 datas 处理逻辑
  watch: {
    datas: {
      immediate: true,
      handler(tNew) {
        this.setData(tNew)
      },
    },
  }

}
</script>

<style lang="scss" scoped>

.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  .title_name {
    padding: 30px 0 20px 100px;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }

  .panel-item_datav {
    padding: 0 30px 20px 30px;
    width: calc(100% - 60px);
    height: 300px;
  }

}

.btns-box {
  display: flex;
  padding-right: 20px;
  gap: 10px;
  font-size: 16px;

  .btn-item {
    width: 60px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url(../../../../assets/head_btn2.png) no-repeat;
    background-size: 100% 100%;
  }

  .btn-item-s {
    width: 60px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url(../../../../assets/head_btn.png) no-repeat;
    background-size: 100% 100%;
  }
}


//表头
::v-deep .header-item {
  height: 38px !important;
  line-height: 38px !important;
  font-size: 18px;
}

//单行
::v-deep .row-item {
  font-size: 18px;
  border-bottom: 1px dashed rgba(255, 255, 255, .2);
}

::v-deep .ceil {
  text-align: center;
}

// 排名
::v-deep .left_box {
  line-height: 30px !important;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking.png) no-repeat;
  background-size: 30px 30px;
}


::v-deep .index0 {
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking1.png) no-repeat !important;
  background-size: 30px 30px !important;
}

::v-deep .index1 {
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking2.png) no-repeat !important;
  background-size: 30px 30px !important;
}

::v-deep .index2 {
  line-height: 30px;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking3.png) no-repeat !important;
  background-size: 30px 30px !important;
}

// 数量
::v-deep .right_box {
  width: 50%;
  height: 24px;
  line-height: 24px;
  background: #00BAFF;
  font-weight: bold;
  color: #06162A;
  transform: translate(50%, 70%);
}
</style>